import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  DialogContentText,
  Box,
  Typography,
} from '@mui/material';
import { useAppSelector, useAppDispatch } from '../../app/hooks';
import {
  selectShowTerminalModeUnderMaintenanceDialog,
  setShowTerminalModeUnderMaintenanceDialog,
} from '@features/view/viewSlice';

const TerminalModeUnderMaintenanceDialog = () => {
  const dispatch = useAppDispatch();

  const showTerminalModeUnderMaintenanceDialog = useAppSelector(
    selectShowTerminalModeUnderMaintenanceDialog,
  );
  const handleClose = () => {
    dispatch(setShowTerminalModeUnderMaintenanceDialog(false));
  };

  return (
    <Dialog open={showTerminalModeUnderMaintenanceDialog} maxWidth="xs">
      <DialogTitle>Terminal Mode Under Maintenance</DialogTitle>
      <DialogContent
        dividers
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 1,
        }}
      >
        <DialogContentText textAlign={'center'}>
          We&apos;re currently performing maintenance on Terminal Mode to bring
          you improved features and performance.
        </DialogContentText>
        <Box
          sx={{
            backgroundColor: (theme) =>
              theme.palette.mode === 'dark'
                ? theme.palette.grey[800]
                : theme.palette.grey[200],
            display: 'flex',
            flexDirection: 'column',
            gap: 1,
            alignItems: 'center',
            borderRadius: 1,
            padding: 1,
            border: (theme) => `1px solid ${theme.palette.divider}`,
          }}
        >
          <Typography>⏱️ Estimated time</Typography>
          <Typography color="secondary" variant="h4" component={'p'}>
            ~30 minutes
          </Typography>
        </Box>
        <DialogContentText textAlign={'center'} variant="body2">
          Please check back soon!
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Okay</Button>
      </DialogActions>
    </Dialog>
  );
};

export default TerminalModeUnderMaintenanceDialog;
